import React from 'react';
import config from 'cfg';
import randomstring from 'randomstring';
import facebookMessengerConfirm from '../../../../../../common/facebookMessengerConfirm';

const {
    bots: {
        messenger: { pageId, appId }
    }
} = config;
class MessengerOptin extends React.Component {
    componentDidMount() {
        window.FB.Event.subscribe(
            'messenger_checkbox',
            function(e) {
                if (e.event === 'rendered') {
                    console.log('Plugin was rendered');
                } else if (e.event === 'checkbox') {
                    var checkboxState = e.state;
                    this.handleCheckboxClick(checkboxState);
                } else if (e.event === 'hidden') {
                    console.log('Plugin was hidden', e);
                }
            }.bind(this)
        );
        window.fbAsyncInit();
    }

    state = {
        checkboxStatus: 'unchecked',
        prechecked: false,
        userRef: randomstring.generate({ length: 48 })
    };

    handleCheckboxClick = status => {
        const { userRef } = this.state;
        this.setState(
            {
                checkboxStatus: status
            },
            () => {
                if (status === 'checked') {
                    setTimeout(() => {
                        facebookMessengerConfirm({
                            appId,
                            pageId,
                            userRef
                        });
                        this.props.onCheck(userRef);
                    }, 500);
                } else {
                    this.props.onUncheck(userRef);
                }
            }
        );
    };

    render() {
        return (
            <div
                className="fb-messenger-checkbox"
                data-origin={window.location.origin}
                data-page_id={pageId}
                data-messenger_app_id={appId}
                data-user_ref={this.state.userRef}
                data-prechecked={this.state.prechecked}
                data-allow_login="true"
                data-size="large"
            />
        );
    }
}

export default MessengerOptin;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/MessengerOptin.js
 **/